import { render, staticRenderFns } from "./IconDelete.vue?vue&type=template&id=58b6f67a&scoped=true&"
import script from "./IconDelete.vue?vue&type=script&lang=js&"
export * from "./IconDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b6f67a",
  null
  
)

export default component.exports